import { ArticlePage2 } from './ArticlePage2.js';

export class ArticlePageSERIEA9 extends ArticlePage2 {
    constructor(containerId) {
        super(containerId, {
            headline: "Patrizia Panico The Enduring Scorpion",
            author: "footballgirl",
                   date: "March 5, 2026",
      image: "images/seriea/9a.jpg",
        content: `<p>Patrizia Panico: 
        The Enduring Scorpion
Patrizia Panico, born in 1975, stands 
as Italy's most capped and prolific Azzurre player,
 her career a saga of longevity,
  leadership, and lethal finishing that 
  earned her the nickname "The Scorpion."</p>
  
 <p> Her youth days with Borussia (1988–1991) and Valmontone (1991–1993) honed her skills before she burst onto the senior scene with Lazio (1993–1996, 71 appearances, 32 goals).
Panico's club journey was a whirlwind of triumphs.
 With Torino (1996–1997, 30 appearances, 32 goals)
  and Modena Amadio (1997–1998, 
  28 appearances, 29 goals),
   she claimed Serie A and the 
   Italian Women's Super Cup. </p>
   
  <p> Back at Lazio (1998–2003, 209 appearances,
    191 goals), she won Serie A in 2002 and
     Coppa Italia in 1999 and 2003.
      A short Milan spell (2003–2004, 
      22 appearances, 5 goals)
       led to another Torino run 
       (2004–2006, 44 appearances, 56 goals). </p>
       
      <p> At Bardolino (2006–2009, 62 appearances,
        73 goals), she lifted the Italian Women's
         Cup in 2007 and 2009, plus Super 
         Cups in 2007 and 2008.</p>

  </p>       
Her peak came with Torres (2009–2014, 
134 appearances, 175 goals),
 dominating with Serie A titles from 2010–2013, Coppa Italia in 2011, and Super Cups from 2009–2013. A 2010 loan to Sky Blue (10 appearances) added international flavor. She later shone with Verona (2014–2015, 25 appearances, 34 goals, Serie A win) and Fiorentina (2015–2016, 21 appearances, 20 goals). Panico was Serie A top scorer 14 times—an Italian record—amassing ten Scudetti and five Coppa Italia.
As Azzurre captain from 1996 to 2014, 
she collected 196 caps and 110 goals.</p>

<p>
Highlights included UEFA Women's Euro 1997
 (group goals, final appearance), 
 the 1999 FIFA Women's World Cup 
 (strikes against Germany and Mexico), 
 and further Euros in 2001 (two opening goals),
  2005, 2009 (two goals, quarter-finals),
   and 2013 (quarter-finals). </p>
   
  <p> Inducted into the Hall of Fame in 2015, 
   Panico transitioned to coaching,
    assisting Italy U16 (2017–2018),
     managing U15 (2018–2021), 
     assisting U21 (2020–2021),
      and leading Fiorentina women (2021–2023).</p>
      
     <p> Her story is one of enduring excellence, 
inspiring the next wave of Italian talent.</p>`,
            tags: [ "Patrizia Panico", "Serie A", "Italy", "nerazurri" ],
            navIndices: { prev: 'seriea-8', next: 'wk-1' }
        });
    }

    init() {
        console.log('ArticlePageSERIEA9 initialized');
        super.init();
    }

    render() {
        super.render();
        
        const backBtn = this.element.querySelector('#articleBackBtn');
        if (backBtn) {
            backBtn.innerHTML = `
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width: 16px; height: 16px; margin-right: 6px;">
                    <line x1="19" y1="12" x2="5" y2="12"></line>
                    <polyline points="12 19 5 12 12 5"></polyline>
                </svg>
                Back to Serie A
            
<div style="margin:24px auto;max-width:720px;text-align:center;"><script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7705230222200385" crossorigin="anonymous"></script><ins class="adsbygoogle" style="display:block;text-align:center;" data-ad-layout="in-article" data-ad-format="fluid" data-ad-client="ca-pub-7705230222200385" data-ad-slot="1708603458"></ins><script>(adsbygoogle = window.adsbygoogle || []).push({});</script></div>
`;
            
            const newBackBtn = backBtn.cloneNode(true);
            backBtn.parentNode.replaceChild(newBackBtn, backBtn);
            
            newBackBtn.addEventListener('click', (e) => {
                e.preventDefault();
                const event = new CustomEvent('navigateHome', { bubbles: true, detail: { anchor: 'seriea' } });
                this.element.dispatchEvent(event);
            });
        }

        const leagueLogo = this.element.querySelector('.hero-util-btn img');
        if (leagueLogo) {
            leagueLogo.src = '/images/league_seriea.png';
            leagueLogo.alt = 'Serie A';
        }
    }
}